import React from "react";
import { connect } from "react-redux";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { userActions } from "../../_actions";
import { busquedaActions } from "../../_actions/busqueda.actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavBarLateral } from "./NavBarLateral";
import MenuFiltro from "../includes/MenuFiltro";
import { FormCambiarPassword } from "../perfil/FormCambiarPassword";
import authService from "../../_services/cart/authService";
import { Link } from "react-router-dom";

import { Formik, Form, Field } from "formik";
import { ERR, ErrorMessage, LoadingBoton, history } from "../../_helpers";
import * as Yup from "yup";
import { userService } from "../../_services";
import alertService from "../../_services/cart/alert.service";
import { C2C } from "../../_helpers/C2C";

const tableRef3 = React.createRef();
const bagRef = React.createRef();
const _ = require("lodash");

class MpModal extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: false,
    show: false,
  };

  componentDidMount() {}

  handleClose = () => {
    this.setState({
      showMp: false,
      show: false,
    });
  };

  render() {
    const user = authService.getLoggedUser();
    const { show, handleClose } = this.props;

    // Los secretos ya no llegan al navegador: el back solo dice si estan cargados. Si lo estan,
    // el campo arranca vacio y vacio significa "no cambiar".
    const privateKeyCargada = !!user?.detail?.mercadoPagoPrivateKeyCargada;
    const webhookKeyCargada = !!user?.detail?.mercadoPagoWebhookKeyCargada;

    let inic = {
      mercadoPagoWebhookKey: "",
      mercadoPagoPublicKey: user?.detail?.mercadoPagoPublicKey ?? "",
      mercadoPagoPrivateKey: "",
    };

    const secreto = (cargada, mensajeMin) => {
      const base = Yup.string().min(12, mensajeMin).max(100, "Demasiado largo");
      return cargada ? base : base.required("Requerido");
    };

    const validationSchema = Yup.object().shape({
      mercadoPagoWebhookKey: secreto(webhookKeyCargada, "Web Hook Clave Privada debe tener al menos 15 caracteres"),

        mercadoPagoPublicKey: Yup.string()
        .required("Requerido")
        .min(12, "Public Key tener al menos 15 caracteres")
        .max(100, "Demasiado largo"),

        mercadoPagoPrivateKey: secreto(privateKeyCargada, "La Access Key debe tener al menos 15 caracteres")
    });
    
    return (
      <>
        <div className="dashboard">
          <NavBarLateral handleClose={this.handleClose} />
          <div className="dashboard__content">

          <div className="dashboard__content-header">
              <div className="dashboard__content-title">
                <h2>
                  Para configurar las comisiones que Mercado Pago cobra, ingresa al siguiente Instructivo 
                  <br/>
                  <br/>
                   <button className="button" data-type="complementary" type='button' onClick={() => history.push('/vendedor/miMpComision')}>
                      Ver Configuración Comisiones
                    </button>
                </h2>
              </div>
            </div>
            <hr></hr>

            <div className="dashboard__content-header">
              <div className="dashboard__content-title">
                <h2>
                  ¿Comó activar Mercado Pago para convertirme en vendedor?
                </h2>
              </div>
            </div>

            <div className="dashboard__content-main">
              <div className="mp__steps">
                <h3>Paso a Paso</h3>
                <div className="dashboard__content-prod-mpSteps">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/FB4aL9D0Of4?si=zZTW1Zdhr5jwvuVw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <h3>Paso 1</h3>
                <div className="dashboard__content-prod-mpSteps">
                  <p>
                    Ingresar en tu cuenta de mercado pago haciendo click aquí en el siguiente link:
                    &nbsp;
                    <a href="https://www.mercadopago.com.ar/" target="_blank">
                       Mercado pago
                    </a>
                  </p>
                </div>

                <h3>Paso 2</h3>
                <div className="dashboard__content-prod-mpSteps">
                  Una vez iniciada la sesión en mercado pago vamos al menu de la izquierda:
                  <ol>
                    <li>Tu Negocio</li>
                    <li>Configuración</li>
                    <li>Credenciales</li>
                    <li>Crear Aplicación</li>
                    <li>Elegir cualquier nombre de aplicacion y seleccionar Pagos Online</li>
                    <li>Compartí las credenciales con un desarrollador</li>
                    <li>Email de la cuenta que recibira acceso:&nbsp;

                    <input className="w-100" value={`deautopartes100@gmail.com`}
                        onChange={({target: {value}}) => this.setState({value, copied: false})} />
                    <C2C 
                        text={`deautopartes100@gmail.com`}
                        render={({ copied, handleClick }) =>
                        copied? <div className="text-right flash">
                          <p className="font-weight-bold"> ¡Copiado!</p></div>
                            : <div className="text-right">
                              <button data-type='primary' type="button" className="button cursor" onClick={handleClick}>
                                <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'} icon="fa-solid fa-copy"></FontAwesomeIcon>
                                Copiar</button>
                                </div>
                            }/>
                    </li>
                  </ol>

                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/compartir-credenciales-mp.png"
                    }
                  ></img>
                </div>

                <h3>Paso 3</h3>
                <div className="dashboard__content-prod-mpSteps">
                Una vez Compartido las credenciales vamos a configurar las Notificaciones para recibir novedades de compras de tu cuenta en la siguiente pagina:
                

                <a href="https://www.mercadopago.com.ar/developers/panel/app/" target="_blank">
                       Mercado pago Developers
                    </a>
                <ol>
                  <li>Notificaciones
                  <ol type="A">
                    <li>En el menu de la izquierda: Webhooks</li>
                    <li>Configurar notificaciones</li>
                  </ol>
                  </li>
                  <li>Seleccionar Modo Productivo</li>
                  <li>En URL de produccion:&nbsp;

                  <div className="form-group">
                  <input value={`https://deautopartes.ar/public/mp/notificacion/${user.detail.userIdentifier}`}
                        onChange={({target: {value}}) => this.setState({value, copied: false})} />
                  <C2C 
                        text={`https://deautopartes.ar/public/mp/notificacion/${user.detail.userIdentifier}`}
                        render={({ copied, handleClick }) =>
                        copied? <div className="text-right flash">
                          <p className="font-weight-bold"> ¡Copiado!</p></div>
                            : <div className="text-right">
                              <button type="button" data-type='primary' className="button cursor" onClick={handleClick}>
                                <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'} icon="fa-solid fa-copy"></FontAwesomeIcon>
                                Copiar</button>
                                </div>
                            }/>
                       
                   </div>
                  
                   </li>

                   <li>Tildar opciones "Pagos", "Wallet Connect" y "Order (Mercado Pago)"</li>
                   <li>Copiar la Clave secreta en el siguiente campo</li>
                </ol>
                </div>
                <Formik
                  enableReinitialize={true}
                  initialValues={inic}
                  validationSchema={validationSchema}
                  onSubmit={(values) => {
                    this.setState({ grabando: true });
                    userService.actualizarMPCredenciales(values).then(
                      (data) => {
                        this.setState({ grabando: false });
                        alertService.msg(
                          "Credenciales Mercado Pago actualizadas exitosamente."
                        );
                      },
                      (error) => {
                        this.setState({ grabando: false });
                        alertService.error(error);
                      }
                    );
                  }}
                >
                  {({ errors, touched, values }) => (
                    <Form>               
                      <h2>Configuración claves</h2>
                <div className="dashboard__content-prod-mpSteps">
                  <h3> Access Key</h3>
                    <ol>                    
                      <div className="form-group">
                            <Field
                              name="mercadoPagoPrivateKey"
                              className="input--outline"
                              type={"password"}
                              autoComplete="off"
                              placeholder={privateKeyCargada ? "Ya está cargada. Dejala vacía para no cambiarla." : ""}
                            />
                            <ErrorMessage name={`mercadoPagoPrivateKey`} />
                          </div>                   
                    </ol>

                    <h3> Public Key</h3>
                    <ol>                    
                      <div className="form-group">
                            <Field
                              name="mercadoPagoPublicKey"
                              className="input--outline"
                              type={"text"}
                            />
                            <ErrorMessage name={`mercadoPagoPublicKey`} />
                          </div>                   
                    </ol>

                    <h3> Webhook Clave Secreta</h3>
                    <ol>                    
                      <div className="form-group">
                            <Field
                              name="mercadoPagoWebhookKey"
                              className="input--outline"
                              type={"password"}
                              autoComplete="off"
                              placeholder={webhookKeyCargada ? "Ya está cargada. Dejala vacía para no cambiarla." : ""}
                            />
                            <ErrorMessage name={`mercadoPagoWebhookKey`} />
                          </div>                   
                    </ol>

                  <p>Esperar hasta 24hs para que los administradores aprueben las credenciales</p>
                </div>
                      <div className="login__socialButtons">
                        <div className="footer__buttons">
                          <button
                            className="button"
                            type="submit"
                            data-type="primary"
                            disabled={this.state.grabando}
                          >
                            Grabar
                            <LoadingBoton grabando={this.state.grabando} />
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapState(state) {
  return {};
}

const actionCreators = {};

const connectedMpModal = connect(mapState, actionCreators)(MpModal);
export { connectedMpModal as MpModal };
